export const STRAND_TYPE = {
  PLUS: "+",
  MINUS: "-",
  UNKNOWN: ".",
};
